import React from "react";
import { AppMarkdown } from "../../../../shared/AppMarkdown/AppMarkdown";
import StandardButton from "../../../../shared/formComponents/StandardButton/StandardButton";
import { SUMMARY_FIELD } from "../../_config/okrPlansCoachConfig";
import { OpcAssistantIcon } from "../OpcChatView/OpcChatView";
import "./_opc-card-bubble.scss";

// ═══════════════════════════════════════════════════════════════════════════
// A card in a coach chat (CD23, CD33): the assistant's SME-look bubble
// with the proposed text in today's remark box and two StandardButtons.
//   remark card      BE 2.8 — Save remark / Keep editing (a newer one expires it)
//   summary change   BE 2.9 — Apply / Not now (`field` is always
//                    `executive_summary`, `new_text`; CD47)
// Once answered the buttons give way to a one-line outcome.
// ═══════════════════════════════════════════════════════════════════════════

const KIND = {
  remark: {
    confirm: "Save remark",
    confirming: "Saving…",
    decline: "Keep editing",
    outcome: {
      SAVED: "Remark saved",
      EXPIRED: "Replaced by a newer draft",
      DISMISSED: "You kept editing",
    },
  },
  change: {
    confirm: "Apply",
    confirming: "Applying…",
    decline: "Not now",
    outcome: { APPLIED: "Applied to the summary", DISMISSED: "Not applied" },
  },
};

const OpcCardBubble = ({
  kind,
  card,
  readOnly,
  busy,
  error,
  onConfirm,
  onDecline,
}) => {
  const k = KIND[kind];
  const pending = card.status === "PENDING" && !readOnly;
  const outcome = k.outcome[card.status];
  const body = kind === "remark" ? card.remark : card.new_text;
  return (
    <div className="cp-message-row cp-message-row--assistant d-flex align-items-start w-100">
      <OpcAssistantIcon />
      <div className="cp-bubble-wrap">
        <div className="cp-bubble cp-bubble--assistant opc-cardb">
          {card.text ? <AppMarkdown>{card.text}</AppMarkdown> : null}
          {kind === "change" ? (
            <span className="light-text small fw-bold d-block mt-2">
              {SUMMARY_FIELD[card.field] || SUMMARY_FIELD.executive_summary}
            </span>
          ) : null}
          {body ? (
            <div
              className={`coach-remarks-main p-3 mt-2 small${
                card.status === "EXPIRED" || card.status === "DISMISSED"
                  ? " opc-cardb--faded"
                  : ""
              }`}
            >
              <AppMarkdown>{body}</AppMarkdown>
            </div>
          ) : null}
          {error ? <p className="opc-cardb__error small">{error}</p> : null}
          {pending ? (
            <div className="d-flex align-items-center gap-2 mt-3">
              <StandardButton
                text={busy ? k.confirming : k.confirm}
                color="btn-rounded-brand-blue-new"
                className="btn-xs"
                disabled={busy}
                onClick={onConfirm}
              />
              <StandardButton
                text={k.decline}
                color="btn-outline-brand-blue-new"
                className="btn-xs"
                disabled={busy}
                onClick={onDecline}
              />
            </div>
          ) : outcome ? (
            <div className="review-completed d-inline-flex align-items-center mt-3">
              <img
                src="/assets/images/true-sucess.svg"
                className="me-1"
                alt=""
              />
              {outcome}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default OpcCardBubble;
